import React, { useState } from 'react';
import Axios from 'axios';
import { serviceInstance } from 'libs';
import ImageUploadStates from './image-states';

const ImageUpload = (props) => {
  const [state, setState] = useState(1);
  const [prog, setProg] = useState(0);

  const baseUrl = window._env_.REACT_APP_BASEURL;

  const uploadToDrake = async (fileData) => {
    setState(2);
    try {
      const result = await Axios.post(`${baseUrl}file-storage/file`, fileData, {
        headers: {
          Authorization: serviceInstance.defaults.headers.common.Authorization,
          'Content-type': 'multipart/form-data',
          accept: 'application/json',
        },
      });
      setProg(100);
      setState(3);
      return props.onUpload(result?.data?.data?.uri, result?.data?.data?.id);
    } catch (e) {
      setState(1);
      setProg(0);
      return props.onError();
    }
  };

  return (
    <ImageUploadStates
      {...props}
      state={state}
      setState={setState}
      prog={prog}
      setProg={setProg}
      uploadToDrake={uploadToDrake}
    />
  );
};

export default ImageUpload;
